module.exports = new __parcel__URL__("Charlie_Display-Black.78320021.woff").toString();